import { useLocation } from 'react-router-dom';

import { paths } from 'src/routes/paths';

import { EmailInboxIcon } from 'src/assets/icons';

import { FormHead } from '../../components/form-head';
import { FormReturnLink } from '../../components/form-return-link';

// ----------------------------------------------------------------------

export function FirebaseVerifyView() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const email = queryParams.get('email'); // Extract the 'email' query parameter

  return (
    <>
      <FormHead
        icon={<EmailInboxIcon />}
        title="Please check your email!"
        description={
          <>
            If we find an account with the email: <strong>{email}</strong>, you will receive a reset
            password link. Please wait up to 5 minutes for it to reach your inbox.
          </>
        }
      />

      <FormReturnLink href={paths.auth.signIn} sx={{ mt: 0 }} />
    </>
  );
}
